import React from "react";
import {useTranslation} from "next-i18next";
import {useAppDispatch, useAppSelector} from "../../app/hooks";
import {useRouter} from "next/router";
import {selectSubscriptions} from "../../redux/upgrade/subscriptionSlice";
import {Hero} from "../text";
import {UpgradeSubscriptionOptionsView} from "./UpgradeSubscriptionOptionsView";

export const UpgradeLandingHeaderSectionView: React.FC<any> = () => {
  const { t } = useTranslation()
  const dispatch = useAppDispatch()
  const router = useRouter()

  const subscriptions = useAppSelector(selectSubscriptions)
  const subscriptionDetailsWidth = subscriptions.length * 18 + ((subscriptions.length - 1))
  const subscriptionDetailsClassName = `mt-3 hidden lg:flex items-center space-x-3 items-center w-[calc(${subscriptionDetailsWidth}rem)]`

  return <div className="grid grid-cols-1 lg:grid-cols-3 xl:grid-cols-2 gap-x-6 justify-items-center lg:justify-items-start flex-grow items-center px-2 sm:px-8 lg:px-10 mt-4 md:mt-6">
    <div className="col-span-1 lg:col-span-2 xl:col-span-1 lg:text-left mb-10 lg:mb-0 px-4 lg:px-10 py-4 sm:py-8 lg:py-0">
      <Hero className="mb-12 lg:mb-16 text-center lg:text-left">
        Get weekly macro updates and more with <span className="text-fg-primary font-bold">FitGenie Premium.</span>
      </Hero>

      <UpgradeSubscriptionOptionsView />
    </div>
    <div className="relative col-span-1 hidden lg:block min-w-screen lg:min-w-[calc(33vw-3.25rem)] xl:min-w-[calc(50vw-3.25rem)] lg:min-h-screen-3/4 xl:max-h-screen mb-8">
      <img
        src="../images/landing_graphic_bison_meatballs.webp"
        className={`absolute inset-y-1/5 transition-opacity transform -translate-x-1/2 inset-x-1/14 w-36 lg:w-44 object-contain`}
      />

      <img
        src="../images/landing_graphic_shrimp_and_grits.webp"
        className={`absolute inset-y-3/5 transition-opacity transform -translate-x-1/2 inset-x-13/14 w-36 lg:w-44 object-contain`}
      />

      <img
        src="../images/upgrade_graphic_recipe.webp"
        className={`absolute inset-x-2/3 inset-y-1/2 transform -translate-y-1/2 -translate-x-1/2 drop-shadow-2xl transition-opacity max-h-screen-1/3 lg:max-h-screen-1/2 xl:max-h-screen-2/3 object-contain lg:w-2/3`}
      />

      <img
        src="../images/upgrade_graphic_weekly_update.webp"
        className={`absolute inset-x-1/3 inset-y-1/2 transform -translate-y-1/2 mt-6 -translate-x-1/2 drop-shadow-2xl transition-opacity max-h-screen-1/3 lg:max-h-screen-1/2 xl:max-h-screen-2/3 object-contain lg:w-2/3`}
      />

      <img
        src="../images/landing_graphic_mango.webp"
        className={`absolute inset-y-2/3 transition-opacity inset-x-1/10 md:inset-x-1/8 lg:inset-x-1/20 w-20 lg:w-24 object-contain`}
      />

      <img
        src="../images/landing_graphic_rosemary.webp"
        className={`invisible lg:visible absolute inset-y-1/8 transition-opacity inset-x-1/10 md:inset-x-1/8 lg:inset-x-0 w-6 lg:w-10 object-contain`}
      />

      <img
        src="../images/landing_graphic_bell_pepper.webp"
        className={`absolute inset-y-1/8 transition-opacity transform -translate-x-1/2 inset-x-9/10 md:inset-x-7/8 lg:inset-x-9/10 w-20 lg:w-24 object-contain`}
      />

      <img
        src="../images/landing_graphic_orange.webp"
        className={`absolute inset-y-9/20 transition-opacity transform -translate-x-1/2 inset-x-3/4 md:inset-x-2/3 lg:inset-x-3/4 w-24 lg:w-28 object-contain`}
      />

      <img
        src="../images/landing_graphic_herb.webp"
        className={`invisible lg:visible absolute inset-y-5/6 transition-opacity transform -translate-x-1/2 inset-x-1/2 md:inset-x-1/2 lg:inset-x-1/2 w-16 lg:w-20 object-contain`}
      />
    </div>
  </div>
}